import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Modal,
} from "@themesberg/react-bootstrap";

import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faPencilAlt,
} from "@fortawesome/free-solid-svg-icons";

import {
  GetSingleFakultas,
  CreateFakultas,
  EditFakultas,
  reset,
} from "../../../features/FakultasSlice";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

const FormData = () => {
  const [newData, setNewData] = useState({
    kode: "",
    nama: "",
  });

  const dispatch = useDispatch();
  const { data, isEdit, isCreate, isLoading } = useSelector(
    (state) => state.fakultas
  );

  const token = localStorage.getItem("token");
  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(GetSingleFakultas({ id, token }));
    }
    if (isEdit || isCreate) {
      navigate("/master/fakultas/list");
    }
  }, [id, dispatch, token, isEdit, navigate, isCreate]);

  useEffect(() => {
    setNewData({ kode: data?.data?.kode, nama: data?.data?.nama });
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (id) {
      dispatch(reset());
      dispatch(
        EditFakultas({
          id: id,
          nama: newData.nama,
          kode: newData.kode,
          token: token,
        })
      );
    } else {
      dispatch(reset());
      dispatch(
        CreateFakultas({
          nama: newData.nama,
          kode: newData.kode,
          token: token,
        })
      );
    }
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/fakultas/edit/${id}`}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="me-2" />
              Edit
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/fakultas/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "edit" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/fakultas/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <Card>
        <ModalLoading isLoading={isLoading} />

        {param.pathname.split("/")[3] === "view" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
            isLocked={true}
          />
        ) : param.pathname.split("/")[3] === "add" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
          />
        ) : param.pathname.split("/")[3] === "edit" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
            id={id}
          />
        ) : null}
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  newData,
  setNewData,
  handleSubmit,
  isLocked = false,
  id,
}) => {
  return (
    <Card.Body>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12} className="mb-3">
            <Form.Group id="kode">
              <Form.Label>Kode</Form.Label>
              <Form.Control
                required
                disabled={isLocked}
                type="text"
                placeholder="Kode"
                name="kode"
                value={newData.kode || ""}
                onChange={(e) =>
                  setNewData({ ...newData, kode: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="nama">
              <Form.Label>Nama</Form.Label>
              <Form.Control
                required
                disabled={isLocked}
                type="text"
                placeholder="Nama"
                name="nama"
                value={newData.nama || ""}
                onChange={(e) =>
                  setNewData({ ...newData, nama: e.target.value })
                }
              />
            </Form.Group>
          </Col>
        </Row>
        <div>
          {!isLocked ? (
            <Button type="submit">{id ? "Update" : "Simpan"}</Button>
          ) : null}
        </div>
      </Form>
    </Card.Body>
  );
};

const ModalLoading = ({ isLoading }) => {
  return (
    <Modal as={Modal.Dialog} centered show={isLoading}>
      <Modal.Body>
        <p>Loading...</p>
      </Modal.Body>
    </Modal>
  );
};

export default FormData;
